import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EandoService } from '../../../../../../api-services/eando.service';
// import { PackageAttachment } from '../../../../../../models/packages/package.model';
import { SharedService } from '../../../../../../services';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.css']
})
export class UploadDocumentComponent implements OnInit {

  @Input() selectedFiles;
  @Input() eandOId;

  newUploadedFile = [];
  fileTypeList: any = [];
  fileUploadValid: boolean = true;

  errorMessages = [];
  errorMessagesFileFormat = [];
  errorMessagesFileData = [];
  isfileErrorShow = false;
  maxAllowedFiles = 50;
  fileId = 0;
  uploadFile: {
    id: number,
    file: File,
    fileName: string,
    fileTypeId: string,
    description: string,
    errorMessagesFileFormat?: string,
    errorMessagesFileSize?: string,
    errorMessagesFileType?: string
  }
  isErrorInSelectedDoc: boolean = false;

  constructor(public activeModal: NgbActiveModal, private eandoService: EandoService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.getSelectedFiles();
  }

  getSelectedFiles() {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.uploadFile = {
        id: this.fileId++,
        file: this.selectedFiles[i],
        fileName: this.selectedFiles[i].name,
        fileTypeId: null,
        description: "",
      };

      this.newUploadedFile.push(this.uploadFile);
    }
    this.getValidFiles();
  }

  private getValidFiles() {

    let isValid = true;
    this.fileUploadValid = true;
    const supportedExt = "application/pdf, image/jpg, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"

    for (let i = 0; i < this.newUploadedFile.length; i++) {
      let file = this.newUploadedFile[i].file;

      let ext = file.type;
      let size = file.size;

      if (supportedExt.includes(ext)) {
        isValid = true;
        if (size > 10485760) {
          this.fileUploadValid = false;
          this.newUploadedFile[i].errorMessagesFileSize = "Maximum file size allowed is 10MB"
        }
      } else {
        this.fileUploadValid = false;
        this.newUploadedFile[i].errorMessagesFileFormat = "Invalid file format! Allowed file format is .pdf, .doc, .docx, .jpg, .jpeg, and .xlsx"
      }

      if(i == this.newUploadedFile.length - 1 && this.fileUploadValid && !this.isErrorInSelectedDoc){
        this.uploadFiles();
      }
    }
  }

  close(action): void {
    this.activeModal.close(action);
  }

  private BindValidFilesToGrid(i: number) {

    this.uploadFile = {
      id: i + 1,
      file: this.selectedFiles[i],
      fileName: this.selectedFiles[i].name,
      fileTypeId: null,
      description: ""
    };

    this.newUploadedFile.push(this.uploadFile);
  }

  uploadFiles() {
    this.errorMessagesFileData = [];
    this.errorMessages = [];
    this.sharedService.showLoader();
    var files = this.newUploadedFile;
    var formData = new FormData();
    let unseletedFileType = [];

    for (var i = 0; i < this.newUploadedFile.length; i++) {
      let fileName = files[i].fileName;

      formData.append('file', files[i].file, files[i].fileName);
      formData.append('fileName', files[i].fileName);
      formData.append('fileTypeId', files[i].fileTypeId);
      formData.append('description', files[i].description == "" ? "//" : files[i].description + '//');

    }

    this.eandoService.uploadEAndOAttachments(this.eandOId,formData).subscribe(
      response => {
        if (response > 0) {
          this.sharedService.showToastMessage("File(s) uploaded successfully");
          this.activeModal.close(true);
        }

        this.sharedService.hideLoader();

        this.activeModal.close(true);

      },
      error => {
        this.sharedService.hideLoader();
        this.errorMessages.push(error.message);
      });
  }

  removedSelectedFile(id) {  
    this.isErrorInSelectedDoc = true; 
    const index = this.newUploadedFile.findIndex(f => f.id == id);
    if (index > -1) {
      this.newUploadedFile.splice(index, 1);
    }

    if (this.newUploadedFile.length == 0) {
      this.isfileErrorShow = false; // !this.isfileErrorShow;
      this.activeModal.close(false);
    } else {
      this.getValidFiles();
    }

  }

}
